import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(value: any, args: any, fieldName?: string): any {
    if (!value) {
      return '';
    }
    let patternToCheck = args;
    if (
      fieldName &&
      fieldName === 'account' &&
      patternToCheck.length >= 4 &&
      patternToCheck.indexOf('-') === -1 &&
      value.indexOf(args) === -1
    ) {
      patternToCheck = patternToCheck.substr(0, 3) + '-' + patternToCheck.substr(3, patternToCheck.length);
    }
    const regex = new RegExp(patternToCheck, 'gi');
    const match = value.match(regex);
    if (match) {
      value = value.replace(regex, '<b style="font-size: 13px;" class="highlight-match sdps-text-active">$&</b>');
      return this.domSanitizer.bypassSecurityTrustHtml(value);
    } else {
      return value;
    }
  }
}
